import {en} from "./translations.en";
import {fr} from "./translations.fr";

export const translations = {
  en: {
    wallet: en,
  },
  fr: {
    wallet: fr,
  },
};
